module.exports = __webpack_public_path__ + "static/media/pic13.2d49a7db.webp";